const PLOTLY_CURSOR_SELECTORS = [".nsewdrag", ".draglayer", ".cursor-crosshair"];

export function setDistributionRedBarHoverPointer(host, active) {
  if (!host) return;
  host.classList.toggle("qaqc-distribution-bar-hover-pointer", !!active);
  for (const sel of PLOTLY_CURSOR_SELECTORS) {
    host.querySelectorAll(sel).forEach((node) => {
      if (active) node.style.cursor = "pointer";
      else node.style.removeProperty("cursor");
    });
  }
}

export function bindRedDistributionBarPointerMove(host, getRedBarPaths, onActiveChange) {
  if (!host || typeof getRedBarPaths !== "function" || typeof onActiveChange !== "function") {
    return () => {};
  }

  const onMove = (e) => {
    const paths = getRedBarPaths();
    let overRed = false;
    for (const path of paths) {
      if (!path) continue;
      const rect = path.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) continue;
      if (
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom
      ) {
        overRed = true;
        break;
      }
    }
    onActiveChange(overRed);
  };

  const onLeave = () => onActiveChange(false);
  host.addEventListener("mousemove", onMove);
  host.addEventListener("mouseleave", onLeave);

  return () => {
    host.removeEventListener("mousemove", onMove);
    host.removeEventListener("mouseleave", onLeave);
  };
}
